<template>
  <div>
    <SearchFilters
      :searchQuery="searchQuery"
      :showSearchBox="showSearchBox"
      @businessChange="handleBusinessChange"
      @branchChange="handleBranchChange"
    />

    <b-container fluid>
      <b-row class="mb-3">
        <b-col cols="12" :md="showAdd ? 12 : 8" class=" ">
          <div class="iq-card ">
            <div class="iq-card-header ">
              <div class="iq-header-title">
                <h4 class="card-title">Orders List</h4>
              </div>
            </div>

            <div class="iq-card-body overflow-auto">
              <b-overlay :show="loading" rounded="sm" variant="Primary"></b-overlay>
              <b-table
                class="table b-table table-striped"
                :items="this.getLocalizedData"
                :fields="
                  columns.map(col => ({ key: col.prop, label: col.label }))
                "
                striped
                ref="table"
              >
                <template v-for="column in columns" #[`cell(${column.prop})`]="data" >
                  <span v-if="!column.isAction">
                    {{ data.item[column.prop] || column.default }}
                  </span>

                  <span v-else>
                    <div class="d-flex justify-content-around">
                      <b-button @click="editMenu(data.item)" variant=" iq-bg-success mr-1 " size="sm">
                        <i class="ri-ball-pen-fill"></i>
                      </b-button>
                    </div>
                  </span>
                </template>
              </b-table>

              <div class="mt-3 d-flex justify-content-center" v-if="!this.searchQuery">
                <b-pagination
                  class="iq-page-primary"
                  v-if="paginationMeta.total > paginationMeta.per_page"
                  v-model="paginationMeta.current_page"
                  :total-rows="paginationMeta.total"
                  :per-page="paginationMeta.per_page"
                  @input="OrdersList"
                />
              </div>
              <EmptySearchMessage v-if="this.EmptySearchMessage" />

              <div v-if="isEmptylist" class="iq-card-header">
                <div class="iq-card-body">
                  <div class="iq-card">
                    <h4 class=" text-center bg-info">
                      You don't have any items in your list
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="6" md="4" class="">
          <div class="iq-card ">
            <Edit
              v-if="!showAdd && editModel"
              :isInList="true"
              @onSubmit="OrdersList()"
              :model="editModel"
              :showAdd="showAdd"
              @showAddChanged="updateShowAddState"
              :branch-id="branchId"
              :business-id="businessId"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import { getAccessToken } from "@/Utils/authentication";
import FormGenerator from "@/components/FormGenerator/FormGenerator.vue";
import TableConfiguration from "./TableConfiguration";
import moment from "moment";
import Edit from "./Edit.vue";
import { core } from "@/config/pluginInit";
import Error_messages from "@/helpers/error_messages.vue";
import SearchFilters from "@/components/SearchFilters.vue";
import EmptySearchMessage from "@/components/EmptySearchMessage.vue";
import { getBusinessOrdersList, deleteOrder } from "@/API/OrdersAPIs";
import Pusher from "pusher-js";
import { PUSHER_KEY, BASE_URL, ENABLE_WS } from "@/config/config";

Vue.prototype.$pusher = new Pusher(PUSHER_KEY, {
  cluster: "ap2",
  authEndpoint: BASE_URL + "/api/pusher/auth",
  auth: {
    headers: {
      Authorization: "Bearer " + getAccessToken(),
      "Access-Control-Allow-Origin": "*"
    }
  }
});
export default {
  name: "OrdersList",
  mixins: [TableConfiguration],
  components: {
    Edit,
    Error_messages,
    SearchFilters,
    EmptySearchMessage,
    FormGenerator
  },
  data() {
    return {
      loading: false,
      items: [],
      searchQuery: "",
      businessId: null,
      branchId: null,
      deletedItem: null,
      showAdd: true,
      editModel: null,
      messages: { error: "", success: "" },
      EmptySearchMessage: false,
      showSearchBox: false,
      isEmptylist: false
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    getLocalizedData() {
      return this.items.map(item => {
        const firstOrderLine = item.orderlines?.[0];
        const locales = firstOrderLine?.data?.item?.locales;

        const localizedData =
          locales?.find(locale => locale.locale === this.currentLocale) ||
          item.locales?.[0];
        return {
          ...item,
          orderlines: localizedData?.name || "",
          created_at: moment(item.created_at).format("DD-MM-YYYY hh:mm A") || ""
        };
      });
    },
    userBusinesses() {
      return this.$store.state.User.user.business || [];
    },
    userBranches() {
      return this.selectedBusiness ? this.selectedBusiness.branches || [] : [];
    }
  },

  async mounted() {
    setTimeout(() => this.connectSocket(), 1000);
    core.index();
  },
  methods: {
    connectSocket() {
      if (ENABLE_WS === "true" && this.branchId) {
        let channelName =
          "private-business-" +
          this.businessId +
          "-branch-" +
          this.branchId +
          "-orders";
        var channel = this.$pusher.subscribe(channelName);
        channel.bind("new-order", response => {
          const newOrder = response.order;
          if (newOrder) this.items = [newOrder, ...this.items];
        });
        channel.bind("update-order", response => {
          const updatedOrder = response.order;
          if (!updatedOrder) return;
          this.items = this.items.map(order =>
            order.id === updatedOrder.id ? updatedOrder : order
          );
        });
      }
    },

    handleBusinessChange(newValue) {
      if (newValue !== this.businessId) {
        this.businessId = newValue;
      }
    },
    handleBranchChange(newValue) {
      if (newValue !== this.branchId) {
        this.branchId = newValue;
        this.OrdersList();
      }
    },
    async OrdersList(page = 1) {
      if (!this.businessId || !this.branchId) return;
      this.loading = true;
      try {
        const perPage = this.searchQuery
          ? this.paginationMeta.total
          : this.paginationMeta.per_page;
        const response = await getBusinessOrdersList({
          businessId: this.businessId,
          branchId: this.branchId,
          "per-page": perPage,
          page
        });
        this.items = response.data;
        if (response.data.length) {
          this.isEmptylist = false;
          this.getLocalizedData.length == 0
            ? (this.EmptySearchMessage = true)
            : (this.EmptySearchMessage = false);
        } else {
          this.isEmptylist = true;
        }

        this.paginationMeta = response.meta;
      } catch (error) {
        console.error(error);
        this.items = [];
      }finally {
      this.loading = false;
    }
    },
    editMenu(model) {
      this.showAdd = false;
      this.editModel = { ...model };
    },
    updateShowAddState(newValue) {
      this.showAdd = newValue;
    }
  },
  watch: {
    userBusinesses: {
      handler(newBusinesses) {
        if (newBusinesses.length > 0 && !this.businessId) {
          this.businessId = newBusinesses[0].id;
        }
      },
      deep: true,
      immediate: true,
    },
    userBranches: {
      handler(newBranches) {
        if (newBranches.length > 0 && !this.branchId) {
          this.branchId = newBranches[0].id;
          if (this.branchId && this.businessId) {
        this.OrdersList();
      }
        }
      },
      deep: true,
    },
  }
};
</script>

<style scoped></style>
